import { apiClient } from './client';

export const updateMyProfile = (data: {
  phone?: string | null;
  whatsapp_opt_in?: boolean;
  name?: string;
  apartment?: string;
}) => apiClient.patch('/users/me', data);

export const dismissWelcome = () => apiClient.patch('/users/me/dismiss-welcome');

export interface TelegramLinkStatus {
  linked:   boolean;
  username?: string;
  linkedAt?: string;
}

export const getTelegramLinkStatus = () =>
  apiClient.get<{ data: TelegramLinkStatus }>('/users/me/telegram');

export const generateTelegramLinkCode = () =>
  apiClient.post<{ data: { code: string; expiresInSeconds: number; deepLink: string | null } }>(
    '/users/me/telegram/link-code', {},
  );

export const unlinkTelegram = () => apiClient.delete('/users/me/telegram');

export const exportPersonalData = () => apiClient.get('/users/me/export', {
  responseType: 'blob',
});

export const deactivateAccount = () => apiClient.post('/users/me/deactivate', {});

export type ReleaseMode = 'auto' | 'notify';

export interface LocationAutomationSettings {
  permissionState: 'unknown' | 'granted' | 'granted_partial' | 'denied' | 'denied_permanently';
  rationaleShownAt: string | null;
  rationaleDeclinedAt: string | null;
  releaseEnabled: boolean;
  releaseHours: number;
  releaseWindowStartLocal: string | null;
  releaseWindowEndLocal:   string | null;
  releaseThresholdM:       number;
  releaseMode:             ReleaseMode;    // v1.1
  releaseIncludeWeekends:  boolean;        // v1.1
  releaseQuietMode:        boolean;        // v2
  releasePausedUntil:      string | null;  // v2: pause auto-expires at midnight
  returnAutoReclaim:       boolean;        // v2
  releaseLastEvaluationAt: string | null;
  releaseLastTriggeredAt:  string | null;
  returnEnabled: boolean;
  returnRadiusM: number;
  returnWindowStartLocal: string | null;
  returnWindowEndLocal:   string | null;
  returnLastEvaluationAt: string | null;
  returnLastTriggeredAt:  string | null;
}

export const getLocationAutomation = () =>
  apiClient.get<{ data: LocationAutomationSettings }>('/users/me/location-automation');

export const updateLocationAutomation = (patch: Partial<{
  releaseEnabled: boolean;
  releaseHours: number;
  releaseWindowStartLocal: string | null;
  releaseWindowEndLocal:   string | null;
  releaseThresholdM: number;
  releaseMode: ReleaseMode;
  releaseIncludeWeekends: boolean;
  releaseQuietMode: boolean;
  releasePausedForToday: boolean;
  returnAutoReclaim: boolean;
  returnEnabled: boolean;
  returnRadiusM: number;
  returnWindowStartLocal: string | null;
  returnWindowEndLocal:   string | null;
  permissionState: LocationAutomationSettings['permissionState'];
  rationaleShownAt: string | null;
  rationaleDeclinedAt: string | null;
}>) => apiClient.patch<{ data: LocationAutomationSettings }>('/users/me/location-automation', patch);

// v1.1 — confirm / dismiss endpoints for notify-mode releases.
export const confirmAutoRelease  = (releaseId: string) =>
  apiClient.post<{ data: { releaseId: string; mode: string; releasedSpotIds: string[]; skippedSpotIds: Array<{ spotId: string; reason: string }>; cancelDeadline: string | null } }>(
    `/sessions/auto-release/${encodeURIComponent(releaseId)}/confirm`);

export const dismissAutoRelease = (releaseId: string) =>
  apiClient.post<{ data: { dismissed: boolean } }>(
    `/sessions/auto-release/${encodeURIComponent(releaseId)}/dismiss`);
